<template>
    <v-container fluid class="pa-4">
        <!-- Sezione Rinnovi in Scadenza -->
        <v-card class="mb-4" v-if="rinnoviInScadenza.length > 0">
            <v-card-title class="warning white--text">
                <v-icon left color="white">mdi-alert-circle</v-icon>
                Rinnovi in Scadenza ({{ rinnoviInScadenza.length }})
            </v-card-title>
            <v-card-text>
                <v-simple-table>
                    <thead>
                        <tr>
                            <th>Scadenza</th>
                            <th>Data Scadenza</th>
                            <th>Importo</th>
                            <th>Azioni</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in rinnoviInScadenza" :key="item.scadenza.id">
                            <td>{{ item.scadenza.titolo }}</td>
                            <td>{{ item.rinnovo.dataScadenza }}</td>
                            <td>{{ item.rinnovo.importoPrevisto }}</td>
                            <td>
                                <v-btn small color="success" @click="apriConfermaRinnovo(item.scadenza)">
                                    Conferma
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>
        </v-card>

        <v-card>
            <!-- Toolbar -->
            <v-toolbar flat>
                <!--  <v-toolbar-title class="text-h5 font-weight-bold">
                    Gestione Scadenze
                </v-toolbar-title>
-->
                <v-spacer />

                <!-- Filtri rapidi -->
                <v-btn icon :color="filtri.mostraStorico ? 'primary' : ''" @click="toggleStorico"
                    v-tooltip.bottom="'Scadenze passate'">
                    <v-icon>history</v-icon>
                </v-btn>

                <v-btn icon :color="filtri.mostraCompletate ? 'success' : ''" @click="toggleCompletate"
                    v-tooltip.bottom="'Scadenze completate'">
                    <v-icon>check_circle</v-icon>
                </v-btn>

                <v-divider vertical class="mx-3" />

                <!-- Filtro periodo -->
                <v-menu ref="menuPeriodo" v-model="menuPeriodo" :close-on-content-click="false"
                    transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="mr-2">
                            <v-icon left>date_range</v-icon>
                            {{ periodoSelezionatoLabel }}
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-text>
                            <v-select v-model="filtri.tipoPeriodo" :items="tipiPeriodo" label="Tipo periodo" outlined
                                dense @change="onTipoPeriodoChange" />

                            <v-select v-if="filtri.tipoPeriodo === 'mese'" v-model="filtri.mese" :items="mesi"
                                label="Mese" outlined dense />

                            <v-select v-if="['mese', 'trimestre', 'quadrimestre'].includes(filtri.tipoPeriodo)"
                                v-model="filtri.anno" :items="anni" label="Anno" outlined dense />

                            <v-select v-if="filtri.tipoPeriodo === 'trimestre'" v-model="filtri.trimestre"
                                :items="trimestri" label="Trimestre" outlined dense />

                            <v-select v-if="filtri.tipoPeriodo === 'quadrimestre'" v-model="filtri.quadrimestre"
                                :items="quadrimestri" label="Quadrimestre" outlined dense />
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn text @click="resetPeriodo">Reset</v-btn>
                            <v-btn color="primary" text @click="applicaPeriodo">Applica</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>

                <!-- Filtro tipologia -->
                <v-autocomplete v-model="filtri.tipologiaId" :items="tipologie" item-text="nome" item-value="id"
                    label="Tipologia" clearable outlined dense hide-details class="mr-2" style="max-width: 400px"
                    @change="caricaScadenze">
                    <template v-slot:selection="{ item }">
                        <v-icon :color="item ? item.coloreHex : '#000'" small class="mr-2 material-symbols-outlined">{{
                            item.iconaMaterial }}</v-icon>
                        {{ item.nome }}
                    </template>
                    <template v-slot:item="{ item }">
                        <v-icon :color="item ? item.coloreHex : '#000'" small class="mr-2 material-symbols-outlined">
                            {{ item.iconaMaterial }}</v-icon>
                        {{ item.nome }}
                    </template>
                </v-autocomplete>

                <!-- Ricerca -->
                <v-text-field v-model="filtri.ricerca" append-icon="search" label="Cerca" single-line hide-details
                    outlined dense clearable style="max-width: 300px" class="mr-2" @input="onRicercaChange" />

                <!-- Pulsante nuovo -->
                <v-btn color="primary" elevation="2" @click="nuovaScadenza">
                    <v-icon left>add</v-icon>
                    Nuovo
                </v-btn>

                <!-- Menu Gestione -->
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" v-bind="attrs" v-on="on" class="ml-2">
                            <v-icon left>settings</v-icon>
                            Gestione
                            <v-icon right>keyboard_arrow_down</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item @click="dialogGestioneTipologie = true">
                            <v-list-item-icon>
                                <v-icon>category</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Gestione Tipologie</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar>

            <v-divider />

            <!-- Tabella -->
            <v-data-table :headers="headers" :items="scadenze" :loading="loading" disable-pagination hide-default-footer
                class="elevation-0" :sort-by="['dataScadenza']" :sort-desc="[false]">

                <!-- Tipologia -->
                <template v-slot:item.tipologia="{ item }">
                    <div class="d-flex align-center">
                        <v-icon :color="item.tipologiaScadenza ? item.tipologiaScadenza.coloreHex : '#000'"
                            class="mr-2">
                            {{ item.tipologiaScadenza.iconaMaterial }}
                        </v-icon>
                        <div>
                            <div class="font-weight-medium">{{ item.tipologiaScadenza.nome }}</div>
                            <div class="text-caption grey--text">{{ item.tipologiaScadenza.categoria }}</div>
                        </div>
                    </div>
                </template>

                <!-- Titolo e dettagli -->
                <template v-slot:item.titolo="{ item }">
                    <div>
                        <div class="font-weight-medium">{{ item.titolo }}</div>
                        <div class="text-caption grey--text" v-if="item.note">
                            {{ item.note | truncate(50) }}
                        </div>
                        <!-- Campi dinamici -->
                        <div class="text-caption mt-1">
                            <v-chip x-small v-if="item.targa" class="mr-1">
                                <v-icon x-small left>car</v-icon>
                                {{ item.targa }}
                            </v-chip>
                            <v-chip x-small v-if="item.nomePc" class="mr-1">
                                <v-icon x-small left>laptop</v-icon>
                                {{ item.nomePc }}
                            </v-chip>
                            <v-chip x-small v-if="item.operatore" class="mr-1">
                                <v-icon x-small left>account</v-icon>
                                {{ item.operatore }}
                            </v-chip>
                        </div>
                    </div>
                </template>

                <!-- Priorità -->
                <template v-slot:item.priorita="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon :color="getPrioritaColor(item.prioritaId)" v-on="on">
                                {{ getPrioritaIcon(item.prioritaId) }}
                            </v-icon>
                        </template>
                        <span>{{ getPrioritaLabel(item.prioritaId) }}</span>
                    </v-tooltip>
                </template>

                <!-- Importo -->
                <!--                 <template v-slot:item.importo="{ item }">
                    <span v-if="item.importo" class="font-weight-medium">
                        € {{ formatImporto(item.importo) }}
                    </span>
                    <span v-else class="grey--text">-</span>
                </template>
 -->
                <!-- Responsabile -->
                <template v-slot:item.responsabile="{ item }">
                    <span v-if="item.responsabile">{{ item.responsabile }}</span>
                    <span v-else class="grey--text">-</span>
                </template>

                <!-- Allegati -->
                <template v-slot:item.allegati="{ item }">
                    <v-tooltip bottom v-if="item.allegati && item.allegati.length > 0">
                        <template v-slot:activator="{ on }">
                            <v-chip small v-on="on">
                                <v-icon small left>attach_file</v-icon>
                                {{ item.allegati.length }}
                            </v-chip>
                        </template>
                        <span>{{ item.allegati.length }} allegato/i</span>
                    </v-tooltip>
                    <span v-else class="grey--text">-</span>
                </template>

                <!-- Stato -->
                <template v-slot:item.completata="{ item }">
                    <v-chip small :color="item.completata ? 'success' : 'warning'" text-color="white">
                        <v-icon small left>
                            {{ item.completata ? 'check_circle' : 'history_toggle_off' }}
                        </v-icon>
                        {{ item.completata ? 'Completata' : 'Da fare' }}
                    </v-chip>
                </template>

                <!-- Scadenza e Rinnovo -->
                <template v-slot:item.rinnovoAttivo.dataScadenza="{ item }">
                    <div v-if="item.rinnovoAttivo">
                        <div>{{ formatData(item.rinnovoAttivo.dataScadenza) }}</div>
                        <v-chip v-if="isRinnovoInScadenza(item.rinnovoAttivo)" x-small color="warning"
                            text-color="white" class="mt-1">
                            <v-icon x-small left>warning_amber</v-icon>
                            In scadenza
                        </v-chip>
                    </div>
                    <span v-else class="grey--text">-</span>
                </template>

                <template v-slot:item.rinnovoAttivo.importoPrevisto="{ item }">
                    € {{ formatImporto(item.rinnovoAttivo.importoPrevisto) }}
                </template>

                <!-- Azioni -->
                <template v-slot:item.azioni="{ item }">

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon small color="primary" v-on="on" @click="modificaScadenza(item)">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </template>
                        <span>Modifica</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon small color="info" v-on="on" @click="duplicaScadenzaAction(item)">
                                <v-icon small>content_copy</v-icon>
                            </v-btn>
                        </template>
                        <span>Duplica</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon small color="error" v-on="on" @click="confermaEliminazione(item)">
                                <v-icon small>delete</v-icon>
                            </v-btn>
                        </template>
                        <span>Elimina</span>
                    </v-tooltip>

                    <!-- NUOVO: Conferma Rinnovo -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon small color="success" v-on="on" @click="apriConfermaRinnovo(item)"
                                :disabled="!item.attiva || !item.rinnovoAttivo">
                                <v-icon small>check_circle</v-icon>
                            </v-btn>
                        </template>
                        <span>Conferma Rinnovo</span>
                    </v-tooltip>

                    <!-- NUOVO: Storico -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon small color="info" v-on="on" @click="apriStoricoRinnovi(item)">
                                <v-icon small>history</v-icon>
                            </v-btn>
                        </template>
                        <span>Storico Rinnovi</span>
                    </v-tooltip>
                </template>

                <!-- No data -->
                <template v-slot:no-data>
                    <div class="text-center py-8">
                        <v-icon size="64" color="grey lighten-1">calendar_today</v-icon>
                        <div class="text-h6 mt-4 grey--text">Nessuna scadenza trovata</div>
                        <v-btn color="primary" class="mt-4" @click="nuovaScadenza">
                            <v-icon left>add</v-icon>
                            Crea la prima scadenza
                        </v-btn>
                    </div>
                </template>
            </v-data-table>
        </v-card>

        <!-- Dialog Form Scadenza -->
        <scadenza-form-dialog v-model="dialogForm" :scadenza="scadenzaCorrente" :tipologie="tipologie" :targhe="targhe"
            :pc="pc" :operatori="operatori" @saved="onScadenzaSalvata" @close="dialogForm = false" />

        <!-- Dialog Conferma Eliminazione -->

        <!-- Snackbar notifiche -->
        <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000">
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.show = false">
                    Chiudi
                </v-btn>
            </template>
        </v-snackbar>

        <gestione-tipologie-dialog v-model="dialogGestioneTipologie" @close="onTipologieDialogClose" />

        <conferma-rinnovo-dialog v-if="scadenzaSelezionata" v-model="dialogConfermaRinnovo"
            :id-scadenza="scadenzaSelezionata.id" @confermato="onRinnovoConfermato" />

        <!-- NUOVO: Dialog Storico -->
        <storico-rinnovi-dialog v-if="scadenzaSelezionata" v-model="dialogStoricoRinnovi"
            :id-scadenza="scadenzaSelezionata.id" :scadenza="scadenzaSelezionata" />
    </v-container>
</template>

<script>
import {
    getTipologieScadenze,
    getScadenze,
    deleteScadenza,
    duplicaScadenza,
    completaScadenza,
    getTarghe,
    getPc,
    getOperatori, getRinnoviInScadenza
} from '@/api/api.scadenze.js';
import ScadenzaFormDialog from './ScadenzaFormDialog.vue';
import GestioneTipologieDialog from './GestioneTipologieDialog.vue';
import ConfermaRinnovoDialog from './ConfermaRinnovoDialog.vue';
import StoricoRinnoviDialog from './StoricoRinnoviDialog.vue';


export default {
    name: 'GestioneScadenze',

    components: {
        ScadenzaFormDialog,
        GestioneTipologieDialog,
        ConfermaRinnovoDialog,
        StoricoRinnoviDialog,
    },

    data() {
        return {
            loading: false,
            scadenze: [],
            tipologie: [],
            targhe: [],
            pc: [],
            operatori: [],

            // Filtri
            filtri: {
                mostraStorico: false,
                mostraCompletate: false,
                tipoPeriodo: 'tutti',
                mese: new Date().getMonth() + 1,
                anno: new Date().getFullYear(),
                trimestre: null,
                quadrimestre: null,
                tipologiaId: null,
                ricerca: ''
            },

            menuPeriodo: false,
            ricercaTimeout: null,

            // Dialog
            dialogForm: false,
            scadenzaCorrente: null,
            scadenzaDaEliminare: null,

            // Snackbar
            snackbar: {
                show: false,
                text: '',
                color: 'success'
            },

            // Headers tabella
            headers: [
                { text: 'Tipologia', value: 'tipologia', sortable: false },
                { text: 'Titolo', value: 'titolo', sortable: true },
                { text: 'Priorità', value: 'priorita', sortable: true, align: 'center' },
                /* { text: 'Importo', value: 'importo', sortable: true }, */
                { text: 'Responsabile', value: 'responsabile', sortable: true },
                { text: 'Allegati', value: 'allegati', sortable: false, align: 'center' },
                { text: 'Stato', value: 'completata', sortable: true },
                { text: 'Prossimo Rinnovo', value: 'rinnovoAttivo.dataScadenza', align: 'center' },
                { text: 'Importo Previsto', value: 'rinnovoAttivo.importoPrevisto', align: 'right' },
                { text: 'Azioni', value: 'azioni', sortable: false, align: 'center', width: '180' },
            ],

            // Opzioni filtri
            tipiPeriodo: [
                { text: 'Tutti', value: 'tutti' },
                { text: 'Mese', value: 'mese' },
                { text: 'Trimestre', value: 'trimestre' },
                { text: 'Quadrimestre', value: 'quadrimestre' },
                { text: 'Anno', value: 'anno' }
            ],

            mesi: [
                { text: 'Gennaio', value: 1 },
                { text: 'Febbraio', value: 2 },
                { text: 'Marzo', value: 3 },
                { text: 'Aprile', value: 4 },
                { text: 'Maggio', value: 5 },
                { text: 'Giugno', value: 6 },
                { text: 'Luglio', value: 7 },
                { text: 'Agosto', value: 8 },
                { text: 'Settembre', value: 9 },
                { text: 'Ottobre', value: 10 },
                { text: 'Novembre', value: 11 },
                { text: 'Dicembre', value: 12 }
            ],

            trimestri: [
                { text: 'Q1 (Gen-Mar)', value: 1 },
                { text: 'Q2 (Apr-Giu)', value: 2 },
                { text: 'Q3 (Lug-Set)', value: 3 },
                { text: 'Q4 (Ott-Dic)', value: 4 }
            ],

            quadrimestri: [
                { text: 'Q1 (Gen-Apr)', value: 1 },
                { text: 'Q2 (Mag-Ago)', value: 2 },
                { text: 'Q3 (Set-Dic)', value: 3 }
            ],

            dialogGestioneTipologie: false,

            dialogConfermaRinnovo: false,
            dialogStoricoRinnovi: false,
            scadenzaSelezionata: null,
            rinnoviInScadenza: []
        };
    },

    computed: {
        anni() {
            const currentYear = new Date().getFullYear();
            const years = [];
            for (let i = currentYear - 2; i <= currentYear + 5; i++) {
                years.push({ text: i.toString(), value: i });
            }
            return years;
        },

        periodoSelezionatoLabel() {
            const { tipoPeriodo, mese, anno, trimestre, quadrimestre } = this.filtri;

            if (tipoPeriodo === 'tutti') return 'Tutti i periodi';
            if (tipoPeriodo === 'anno') return `Anno ${anno}`;
            if (tipoPeriodo === 'mese') {
                const meseObj = this.mesi.find(m => m.value === mese);
                return `${meseObj?.text} ${anno}`;
            }
            if (tipoPeriodo === 'trimestre') {
                const trimObj = this.trimestri.find(t => t.value === trimestre);
                return `${trimObj?.text} ${anno}`;
            }
            if (tipoPeriodo === 'quadrimestre') {
                const quadObj = this.quadrimestri.find(q => q.value === quadrimestre);
                return `${quadObj?.text} ${anno}`;
            }

            return 'Periodo';
        }
    },

    filters: {
        truncate(value, length) {
            if (!value) return '';
            if (value.length <= length) return value;
            return value.substring(0, length) + '...';
        }
    },

    async mounted() {
        await this.caricaDatiIniziali();
        await this.caricaRinnoviInScadenza();
    },

    methods: {
        async caricaDatiIniziali() {
            this.loading = true;
            try {
                const [tipologieRes, targheRes, pcRes, operatoriRes] = await Promise.all([
                    getTipologieScadenze(),
                    getTarghe(),
                    getPc(),
                    getOperatori()
                ]);

                this.tipologie = tipologieRes.data.data;
                this.targhe = targheRes.data.data;
                this.pc = pcRes.data.data;
                this.operatori = operatoriRes.data.data;

                await this.caricaScadenze();
            } catch (error) {
                this.$toast.alert('Errore nel caricamento dei dati');
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        async caricaScadenze() {
            this.loading = true;
            try {
                const params = this.buildFiltriParams();
                const response = await getScadenze(params);
                this.scadenze = response.data.data;
            } catch (error) {
                this.$toast.alert('Errore nel caricamento delle scadenze');
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        buildFiltriParams() {
            const params = {};

            if (this.filtri.mostraStorico) params.mostraStorico = true;
            if (this.filtri.mostraCompletate) params.mostraCompletate = true;
            if (this.filtri.tipologiaId) params.tipologiaId = this.filtri.tipologiaId;
            if (this.filtri.ricerca) params.ricerca = this.filtri.ricerca;

            // Periodo
            if (this.filtri.tipoPeriodo !== 'tutti') {
                params.tipoPeriodo = this.filtri.tipoPeriodo;
                params.anno = this.filtri.anno;

                if (this.filtri.tipoPeriodo === 'mese') {
                    params.mese = this.filtri.mese;
                } else if (this.filtri.tipoPeriodo === 'trimestre') {
                    params.trimestre = this.filtri.trimestre;
                } else if (this.filtri.tipoPeriodo === 'quadrimestre') {
                    params.quadrimestre = this.filtri.quadrimestre;
                }
            }

            return params;
        },

        // Filtri
        toggleStorico() {
            this.filtri.mostraStorico = !this.filtri.mostraStorico;
            this.caricaScadenze();
        },

        toggleCompletate() {
            this.filtri.mostraCompletate = !this.filtri.mostraCompletate;
            this.caricaScadenze();
        },

        onTipoPeriodoChange() {
            const now = new Date();
            this.filtri.anno = now.getFullYear();
            this.filtri.mese = now.getMonth() + 1;
            this.filtri.trimestre = Math.ceil((now.getMonth() + 1) / 3);
            this.filtri.quadrimestre = Math.ceil((now.getMonth() + 1) / 4);
        },

        resetPeriodo() {
            this.filtri.tipoPeriodo = 'tutti';
            this.menuPeriodo = false;
            this.caricaScadenze();
        },

        applicaPeriodo() {
            this.menuPeriodo = false;
            this.caricaScadenze();
        },

        onRicercaChange() {
            clearTimeout(this.ricercaTimeout);
            this.ricercaTimeout = setTimeout(() => {
                this.caricaScadenze();
            }, 500);
        },

        // CRUD
        nuovaScadenza() {
            this.scadenzaCorrente = null;
            this.dialogForm = true;
        },

        modificaScadenza(scadenza) {
            this.scadenzaCorrente = { ...scadenza };
            this.dialogForm = true;
        },

        async duplicaScadenzaAction(scadenza) {
            try {
                await duplicaScadenza(scadenza.id);
                this.$toast.info('Scadenza duplicata con successo');
                await this.caricaScadenze();
            } catch (error) {
                this.$toast.alert('Errore nella duplicazione della scadenza');
                console.error(error);
            }
        },

        async confermaEliminazione(scadenza) {
            this.scadenzaDaEliminare = scadenza;
            this.dialogElimina = true;
            let confirm = await this.$confirm.open(
                "elimina",
                "Eliminare la scadenza selezionata?"
            );

            if (!confirm) return;
            this.eliminaScadenza();
        },

        async eliminaScadenza() {
            try {
                await deleteScadenza(this.scadenzaDaEliminare.id);
                this.dialogElimina = false;
                this.scadenzaDaEliminare = null;
                this.$toast.info('Scadenza eliminata con successo');
                await this.caricaScadenze();
            } catch (error) {
                this.$toast.alert('Errore nell\'eliminazione della scadenza');
                console.error(error);
            }
        },

        async completaScadenza(scadenza) {
            try {
                await completaScadenza(scadenza.id);
                this.$toast.info('Scadenza completata');
                await this.caricaScadenze();
            } catch (error) {
                this.$toast.alert('Errore nel completamento della scadenza');
                console.error(error);
            }
        },

        onScadenzaSalvata() {
            this.dialogForm = false;
            this.scadenzaCorrente = null;
            this.caricaScadenze();
        },

        // Utility
        formatData(data) {
            if (!data) return '-';
            return this.$i2kFunctions.formatISODate(data);
        },

        formatImporto(importo) {
            return new Intl.NumberFormat('it-IT', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(importo);
        },

        getColorScadenza(item) {
            if (item.completata) return 'success';

            const oggi = new Date();
            const dataScadenza = this.$i2kFunctions.formatISODate(item.dataScadenza);

            // Normalizza entrambe le date a mezzanotte
            oggi.setHours(0, 0, 0, 0);

            const msPerGiorno = 1000 * 60 * 60 * 24;
            const giorni = Math.floor((dataScadenza - oggi) / msPerGiorno);

            if (giorni < 0) return 'error';        // Scaduta
            if (giorni <= 7) return 'error';        // Urgente
            if (giorni <= 30) return 'warning';     // Prossima
            return 'grey lighten-2';                // Futura
        },

        isScaduta(item) {
            if (item.completata) return false;
            const oggi = new Date();
            const dataScadenza = this.$i2kFunctions.formatISODate(item.dataScadenza);
            return dataScadenza < oggi;
        },

        isDaCompletare(item) {
            if (item.completata) return false;

            const msPerGiorno = 86400000;
            const giorni = Math.floor(
                (this.$i2kFunctions.formatISODate(item.dataScadenza) -
                    new Date().setHours(0, 0, 0, 0)) / msPerGiorno
            );

            return giorni >= 0 && giorni <= 7;
        },

        getPrioritaIcon(prioritaId) {
            const icons = {
                1: 'error_outline',
                2: 'error',
                3: 'report_gmailerrorred'
            };
            return icons[prioritaId] || 'error_outline';
        },

        getPrioritaColor(prioritaId) {
            const colors = {
                1: 'green',
                2: 'orange',
                3: 'red'
            };
            return colors[prioritaId] || 'grey';
        },

        getPrioritaLabel(prioritaId) {
            const labels = {
                1: 'Bassa',
                2: 'Media',
                3: 'Alta'
            };
            return labels[prioritaId] || 'Non definita';
        },

        onTipologieDialogClose() {
            this.caricaDatiIniziali();
        },

        apriConfermaRinnovo(scadenza) {
            this.scadenzaSelezionata = scadenza;
            this.dialogConfermaRinnovo = true;
        },

        apriStoricoRinnovi(scadenza) {
            this.scadenzaSelezionata = scadenza;
            this.dialogStoricoRinnovi = true;
        },

        onRinnovoConfermato(data) {
            this.dialogConfermaRinnovo = false;
            this.mostraSuccesso('Rinnovo confermato con successo');
            this.caricaScadenze(); // Ricarica lista
        },

        isRinnovoInScadenza(rinnovo) {
            if (!rinnovo.dataScadenza) return false;
            const oggi = new Date();
            const dataScadenza = new Date(rinnovo.dataScadenza);
            const diffGiorni = Math.ceil((dataScadenza - oggi) / (1000 * 60 * 60 * 24));
            return diffGiorni <= 30 && diffGiorni >= 0;
        },

        async caricaRinnoviInScadenza() {
            try {
                const response = await getRinnoviInScadenza(30);
                this.rinnoviInScadenza = response.data.data || [];
            } catch (error) {
                console.error('Errore caricamento rinnovi in scadenza:', error);
            }
        }
    }
};
</script>
